import { request } from '@/shared/api/request'

export const getEContracts = (params) => {
	return request({ url: 'colcontract/ecd/page', method: 'POST', params: params })
}
